module.exports = __webpack_public_path__ + "img/toCard.b4fd454a.png";